/**
 * Application state routes configuration
 *
 * @param {String} _applicationRootPath application root path
 * @return {Object} states config object
 */
'use strict';
var allStates = function allStates(_applicationRootPath) {
  var states = {
    default: {
      frame: {
        header: {
          path: _applicationRootPath + '/riq_frame_com_en/header',
          controller: 'RiqFrameHeaderComEnController as $ctrl'
        }
      },
      state: {
        onboarding_en: {
          path: _applicationRootPath + '/onboarding_com_en',
          url: '/onboarding?subScreen',
          controller: 'OnboardingComEnController as $ctrl'
        },
        library_en: {
          path: _applicationRootPath + '/library_com_en',
          url: '/home',
          controller: 'LibraryComEnController as $ctrl'
        },
        collection_en: {
          path: _applicationRootPath + '/collection_com_en',
          url: '/home/books?id',
          controller: 'CollectionComEnController as $ctrl'
        },
        categories_details_en: {
          path: _applicationRootPath + '/collection_com_en',
          url: '/categories/:id?ref&idx',
          controller: 'CollectionComEnController as $ctrl'
        },
        categories_en: {
          path: _applicationRootPath + '/categories_com_en',
          url: '/categories',
          controller: 'CategoriesComEnController as $ctrl'
        },
        book_player_en: {
          path: _applicationRootPath + '/book_player_com_en',
          url: '/book-player?id&collectionId',
          controller: 'BookPlayerComEnController as $ctrl'
        },
        my_account_en: {
          path: _applicationRootPath + '/my_account_com_en',
          url: '/settings',
          controller: 'MyAccountComEnController as $ctrl'
        },
        my_profile_en: {
          path: _applicationRootPath + '/my_profile_com_en',
          url: '/settings/manage-account',
          controller: 'MyProfileComEnController as $ctrl'
        },
        manage_students_en: {
          path: _applicationRootPath + '/manage_students_com_en',
          url: '/settings/manage-students?step',
          controller: 'ManageStudentsComEnController as $ctrl'
        },
        teacher_dashboard_en: {
          path: _applicationRootPath + '/teacher_dashboard_com_en',
          url: '/dashboard?page&embed',
          controller: 'TeacherDashboardComEnController as $ctrl'
        },
        onboarding_manage_students_en: {
          path: _applicationRootPath + '/manage_students_com_en',
          url: '/onboarding/manage-students',
          controller: 'ManageStudentsComEnController as $ctrl'
        },
        manage_subscription_en: {
          path: _applicationRootPath + '/manage_subscription_com_en',
          url: '/settings/manage-account/{state:subscription|itunes|sams-club}',
          controller: 'ManageSubscriptionComEnController as $ctrl'
        },
        upload_students_en: {
          path: _applicationRootPath + '/upload_students_com_en',
          url: '/settings/manage-students/upload',
          controller: 'UploadStudentsComEnController as $ctrl'
        },
        student_profile_en: {
          path: _applicationRootPath + '/student_profile_com_en',
          url: '/settings/manage-students/{state:edit|add}?profile',
          controller: 'StudentProfileComEnController as $ctrl'
        },
        curriculum_overview_en: {
          path: _applicationRootPath + '/curriculum_overview_com_en',
          url: '/settings/curriculum-overview',
          controller: 'CurriculumOverviewComEnController as $ctrl'
        },
        customer_support_en: {
          path: _applicationRootPath + '/customer_support_com_en',
          url: '/settings/customer-support',
          controller: 'CustomerSupportComEnController as $ctrl'
        },
        legal_en: {
          path: _applicationRootPath + '/legal_com_en',
          url: '/legal/{state:terms|privacy}',
          controller: 'LegalComEnController as $ctrl'
        },
        change_billing_en: {
          path: _applicationRootPath + '/change_billing_com_en',
          url: '/settings/manage-account/billing',
          controller: 'ChangeBillingComEnController as $ctrl'
        },
        update_account_en: {
          path: _applicationRootPath + '/update_account_com_en',
          url:
            '/settings/manage-account/{state:cancel|email|phone-number|password|name}',
          controller: 'UpdateAccountComEnController as $ctrl'
        },
        edit_profile_en: {
          path: _applicationRootPath + '/edit_profile_com_en',
          url: '/settings/child/{state:edit|add|redeem}?profile',
          controller: 'EditProfileComEnController as $ctrl'
        },
        redeem_code_en: {
          path: _applicationRootPath + '/redeem_code_com_en',
          url: '/settings/{state:link-to-classroom|select-child}?code',
          params: {state: 'link-to-classroom'},
          controller: 'RedeemCodeComEnController as $ctrl'
        },
        challenge_en: {
          path: _applicationRootPath + '/challenge_com_en',
          url: '/challenge',
          controller: 'ChallengeComEnController as $ctrl'
        },
        level_en: {
          path: _applicationRootPath + '/level_com_en',
          url: '/level',
          controller: 'LevelComEnController as $ctrl'
        },
        search_en: {
          path: _applicationRootPath + '/search_com_en',
          url: '/search?query',
          controller: 'SearchComEnController as $ctrl'
        },
        my_shelf_en: {
          path: _applicationRootPath + '/my_shelf_com_en',
          url: '/myshelf',
          controller: 'MyShelfComEnController as $ctrl'
        },
        change_profile_en: {
          path: _applicationRootPath + '/my_shelf_com_en',
          url: '/myshelf/changeuser',
          controller: 'MyShelfComEnController as $ctrl'
        },
        change_avatar_en: {
          path: _applicationRootPath + '/my_shelf_com_en',
          url: '/myshelf/changeavatar',
          controller: 'MyShelfComEnController as $ctrl'
        },
        error_en: {
          path: _applicationRootPath + '/error_com_en',
          url: '/404',
          controller: 'ErrorComEnController as $ctrl'
        },
        class_login_en: {
          path: _applicationRootPath + '/class_login_com_en',
          url: '/class-login',
          controller: 'ClassLoginComEnController as $ctrl'
        },
        select_profile_en: {
          path: _applicationRootPath + '/select_profile_com_en',
          url: '/select-user',
          controller: 'SelectProfileComEnController as $ctrl'
        },
        book_intercept_en: {
          url: '/book-intercept?id&collectionId'
        },
        comprehension_check_en: {
          path: _applicationRootPath + '/comprehension_check_com_en',
          url: '/comprehension-check?id&collectionId',
          controller: 'ComprehensionCheckComEnController as $ctrl'
        },
        comprehension_check_final_en: {
          path: _applicationRootPath + '/comprehension_check_final_com_en',
          url: '/comprehension-check-final?id&collectionId&ccId',
          controller: 'ComprehensionCheckFinalComEnController as $ctrl'
        },
        placement_assessment_en: {
          path: _applicationRootPath + '/placement_assessment_com_en',
          url: '/placement-assessment',
          controller: 'PlacementAssessmentComEnController as $ctrl'
        },
        my_badges_en: {
          path: _applicationRootPath + '/my_badges_com_en',
          url: '/my-badges',
          controller: 'MyBadgesComEnController as $ctrl'
        },
        leaderboard_en: {
          path: _applicationRootPath + '/leaderboard_com_en',
          url: '/leaderboard',
          controller: 'LeaderboardComEnController as $ctrl'
        }
      },
      // eslint-disable-next-line no-unused-vars
      otherwise: function($injector, $location) {
        return '/404';
      },
      // empty function redirect is needed in order for / route not trigger a 404, we rely on init-service to complete the when redirect.
      when: [
        ['/', function() {}],
        [/\/settings\/invite-families/, '/settings/manage-students?step=invite']
      ]
    }
  };

  return states;
};

var getStates = function getStates(_applicationRootPath) {
  var states = allStates(_applicationRootPath);
  return states.default;
};

module.exports = {
  getAllStates: allStates,
  getStates: getStates
};
